<template>
    <v-container fluid>
        <notification-form
            :notification="model"
            :titlePrefix="$t('forms.title_prefix.edit')"
            @saved="saved"
        />
    </v-container>
</template>

<script>
import NotificationForm from './Form'
import Notification from '@/models/Notification'

export default {
    components: { NotificationForm },
    props: ['id'],

    data: () => ({ model: new Notification() }),

    methods: {
        async load() {
            this.model = await this.model.find(this.id)
        },
        saved() {
            this.$router.go(-1)
        },
    },

    created() {
        this.load()
    },
}
</script>

<style></style>
